// Copyright (c) 2017 Deere & Company

const spaClaimsSortOptions = [
    {
        displayName: 'CREATED_BY',
        path: ['recordInfo', 'createdBy', 'lastName']
    },
    {
        displayName: 'CLAIM_NUMBER',
        path: ['claimNumber']
    },
    {
        displayName: 'WORK_ORDER_ONE',
        path: ['reference1']
    },
    {
        displayName: 'PIN',
        path: ['pin']
    },
    {
        displayName: 'RESPONSIBLE_DEALER',
        path: ['responsibleAccount', 'account']
    },
    {
        displayName: 'SPECIAL_ALLOWANCE_TYPE',
        path: ['specialAllowanceType', 'value']
    },
    {
        displayName: 'STATUS',
        path: ['status', 'value']
    },
    {
        displayName: 'SUBMITTED',
        path: ['submittedDate']
    }
];

export default spaClaimsSortOptions;



// WEBPACK FOOTER //
// ./src/tabm/wip/services/spa-claims-sort-options.js